<template>
    <div class="contract-work-facts space-y-0.5">
        <our-label v-if="withListLabel"
                   :value="label"
                   color="el-dark"
                   text-class="fs-0.75 font-medium lh-1" />
        
        <div>
            <div v-for="work in displayedWorks"
                 :key="work[idKey]"
                 class="work_item f-x-between _py-0.5 fs-0.75 lh-1">
                <span :class="classes.workName(!!work.blocked_at)">{{ workLabel(work) }}</span>
                <span v-if="!withoutValue" 
                      class="text-gray-400 no-shrink _ml-1">
                    <span>{{ workValue(work) }} {{ unitName(work) }}</span>
                </span>
            </div>
            <div v-if="withDiffCount && diffCount"
                 class="fs-0.75 lh-1 text-accent">
                + еще {{ diffCount }} видов работ
            </div>
        </div>

        <el-button v-if="withOpenDialog"
                   class="w-full"
                   type="primary"
                   size="mini"
                   plain
                   @click="openContractsDialog">
            {{ buttonLabel }}
        </el-button>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

import { getContractNumber, getActualWorkFactUnits, getWorkName, getWorkNumber, getContractDescription } from '@/models/contracts'

export default {
  name: 'ContractWorkFacts',

  props: {
    taskId: { type: String, default: null },

    works: { type: Array, default: () => [] },
    displayedCount: { type: Number, default: 3 },

    contract: { type: Object, default: () => ({}) },

    idKey: { type: String, default: 'id' },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' },
    withLastFact: { type: Boolean, default: false },
    withoutValue: { type: Boolean, default: false },
    withDiffCount: { type: Boolean, default: false },

    withListLabel: { type: Boolean, default: false },
    listLabel: { type: String, default: null },

    withOpenDialog: { type: Boolean, default: false },
    openDialogLabel: { type: String, default: null }
  },

  computed: {
    classes() {
      return {
        workName: isBlocked => ({
          'cross': isBlocked
        })
      }
    },

    displayedWorks() {
      return this.works.slice(0, this.displayedCount)
    },

    contractName() {
      return this.contract && `${getContractNumber(this.contract)} ${getContractDescription(this.contract)}` || ''
    },

    label() {
      return this.listLabel || this.contractName + ':'
    },

    diffCount() {
      return this.works.length - this.displayedWorks.length
    },

    buttonLabel() {
      if (this.openDialogLabel) {
        return this.openDialogLabel
      }

      return this.diffCount && `Еще ${this.diffCount} видов работ` || 'Раскрыть список'
    }
  },

  methods: {
    ...mapMutations({
      showDialog: 'dialog/SHOW_DIALOG'
    }),

    workLabel(work) {
      return this.getNested(work, this.labelKey, null) || `${getWorkNumber(work)} ${getWorkName(work)}` || 'Неизвесто' 
    },

    workValue(work) {
      return this.withLastFact 
        ? getActualWorkFactUnits(work) 
        : this.getNested(work, this.valueKey)
    },

    unitName(work) {
      return work.unit_name || work.data?.unit_name || ''
    },

    openContractsDialog() {
      this.showDialog({
        dialogName: 'contracts',
        multiple: true,
        payload: {
          editedItem: {
            ast_contract_id: this.contract.id,
            ast_work_ids: this.works.map(x => x[this.idKey])
          },
          contract: this.contract,
          taskId: this.taskId,
          readonly: true,

          /**
           * TODO@dependent-place
           */

          withWorks: true,
          wirhWorksSelection: true
        }
      })
    }
  }
}
</script>
